import script from "./CrewingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CrewingComponent.vue?vue&type=script&setup=true&lang=js"

import "./CrewingComponent.vue?vue&type=style&index=0&id=2caa22bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2caa22bb"]])

export default __exports__